// Central content + curated imagery for Janma Foundation.
// NOTE: Photos below are tasteful stock placeholders (Indian NGO context).
// Replace with real Janma Foundation photography when available.

export const IMAGES = {
  hero: "https://images.unsplash.com/flagged/photo-1574097656146-0b43b7660cb6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  children: "https://images.unsplash.com/flagged/photo-1574098335395-18cf525e45d6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  health: "https://images.pexels.com/photos/7179255/pexels-photo-7179255.jpeg?auto=compress&cs=tinysrgb&w=1200",
  womenGroup: "https://images.pexels.com/photos/33808945/pexels-photo-33808945.jpeg?auto=compress&cs=tinysrgb&w=1200",
  womenStanding: "https://images.unsplash.com/photo-1587538018365-2a1f8b544c08?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  skillSewing: "https://images.unsplash.com/photo-1616674202799-054e7c831378?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  skillComputer: "https://images.pexels.com/photos/5530487/pexels-photo-5530487.jpeg?auto=compress&cs=tinysrgb&w=1200",
  elderlyBoy: "https://images.unsplash.com/photo-1780314501266-0158179ba545?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  volunteers: "https://images.pexels.com/photos/6646947/pexels-photo-6646947.jpeg?auto=compress&cs=tinysrgb&w=1200",
  womanHelping: "https://images.unsplash.com/photo-1596450514537-fae68a81346b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Programs", to: "/programs" },
  { label: "Partners", to: "/partners" },
  { label: "Impact", to: "/gallery" },
  { label: "Get Involved", to: "/get-involved" },
  { label: "Contact", to: "/contact" },
];

export const IMPACT_STATS = [
  { value: 25, suffix: "+", label: "Government Schools Supported", sub: "≈ 5,000 students reached" },
  { value: 300, suffix: "+", label: "Health Camps & Blood Drives", sub: "6,000+ people benefited" },
  { value: 500, suffix: "+", label: "Skill-Centre Graduates", sub: "Empowered & self-reliant" },
  { value: 50, suffix: "+", label: "Women Empowered", sub: "Financial independence" },
  { value: 350, suffix: "+", label: "Girl-Child Scholarships", sub: "Full-paid education" },
  { value: 100, suffix: "+", label: "Orphanages & Old-Age Homes", sub: "2,000+ residents cared for" },
  { value: 3500, suffix: "+", label: "Covid Families Supported", sub: "Ration & medical relief" },
  { value: 100, suffix: "+", label: "Social & Green Drives", sub: "Cleaner, greener villages" },
];

export const PROGRAMS = [
  {
    id: "ayush",
    name: "Janma Ayush",
    tag: "Health & Medical Support",
    icon: "HeartPulse",
    image: IMAGES.health,
    desc: "Free medical camps, blood donation drives and preventive healthcare for underserved rural communities.",
  },
  {
    id: "patashala",
    name: "Janma Patashala",
    tag: "Government School Support",
    icon: "School",
    image: IMAGES.skillComputer,
    desc: "Infrastructure, libraries and teaching aids that transform government schools into places of joy.",
  },
  {
    id: "abyasa",
    name: "Janma Abyasa",
    tag: "Girl Child Education & Scholarships",
    icon: "BookOpen",
    image: IMAGES.children,
    desc: "Digital classrooms, learning material and full-paid scholarships that keep girl children in school and dreaming big.",
  },
  {
    id: "abhaya",
    name: "Janma Abhaya",
    tag: "Women Empowerment & Support",
    icon: "ShieldCheck",
    image: IMAGES.womenStanding,
    desc: "Self-help groups, legal aid and micro-enterprise support for single women and widows.",
  },
  {
    id: "vasudha",
    name: "Janma Vasudha",
    tag: "Environment & Waste Management",
    icon: "Leaf",
    image: IMAGES.volunteers,
    desc: "Waste management drives, tree plantations and green initiatives that build cleaner, more sustainable communities.",
  },
  {
    id: "kaushal",
    name: "Janma Kaushal",
    tag: "Skill Development & Livelihoods",
    icon: "Briefcase",
    image: IMAGES.skillSewing,
    desc: "Vocational training in tailoring, computers and trades that turn women and youth into confident, skilled earners.",
  },
];

export const MANIFESTO = [
  { num: "01", title: "Grassroots First", desc: "We work directly on the ground in villages, reaching people the system often forgets." },
  { num: "02", title: "Sacred Trust", desc: "Every contribution is used with full accountability, backed by 12A, 80G and CSR-1 compliance." },
  { num: "03", title: "Dignity, Not Charity", desc: "We build lasting capability so families become self-reliant, never dependent." },
  { num: "04", title: "Whole-Community Care", desc: "Children, girls, single women and elders — we care for the entire circle of a village." },
];

export const CORPORATE_PARTNERS = [
  "Cyient",
  "Biological E. Limited",
  "Standard Engineering",
  "Futureproof",
  "Voith",
  "Wood Mackenzie",
  "Innovapptive",
 ];

export const NGO_PARTNERS = [
  "Raising Shakthi",
  "I & Eye Sharing Vision",
  "Naipunya Association for Skill Development",
  "With You Organization",
  "Lutikurthi Foundation", 
];

export const TRANSPARENCY = [
  { label: "Registration No.", value: "439/2014" },
  { label: "PAN", value: "AADAJ4366N" },
  { label: "12A Registered", value: "Yes — Tax exempt" },
  { label: "80G Certified", value: "Yes — Donor tax benefit" },
  { label: "CSR-1 Registered", value: "Eligible for CSR funding" },
  { label: "NGO Darpan ID", value: "Registered with NITI Aayog" },
];

export const GALLERY = [
  { src: IMAGES.hero, alt: "Girls learning in a government school", cat: "Education" },
  { src: IMAGES.health, alt: "Rural health check-up camp", cat: "Health" },
  { src: IMAGES.skillSewing, alt: "Women at a tailoring skill centre", cat: "Skill Development" },
  { src: IMAGES.womenStanding, alt: "Women empowerment group", cat: "Women Empowerment" },
  { src: IMAGES.children, alt: "Children supported in school", cat: "Education" },
  { src: IMAGES.skillComputer, alt: "Computer literacy training", cat: "Skill Development" },
  { src: IMAGES.elderlyBoy, alt: "Elder and child at an orphanage", cat: "Orphan & Elder Care" },
  { src: IMAGES.volunteers, alt: "Volunteers packing relief kits", cat: "Social Activities" },
  { src: IMAGES.womenGroup, alt: "Community celebration", cat: "Happiness" },
];

export const TESTIMONIALS = [
  {
    id: "t1",
    name: "Lakshmi Devi",
    role: "Mother, Patancheru Government School",
    photo: "https://images.pexels.com/photos/37798732/pexels-photo-37798732.jpeg?auto=compress&cs=tinysrgb&w=400",
    text: "My daughter gets free books, uniforms and a caring teacher because of Janma Foundation. She dreams of becoming a doctor now.",
  },
  {
    id: "t2",
    name: "Ramesh Naik",
    role: "Skill-Centre Graduate, Janma Kaushal",
    photo: "https://images.pexels.com/photos/34770131/pexels-photo-34770131.jpeg?auto=compress&cs=tinysrgb&w=400",
    text: "The tailoring training gave me a trade and my own small shop. For the first time, I don't depend on daily wage work.",
  },
  {
    id: "t3",
    name: "Anitha Reddy",
    role: "Self-Help Group Member, Janma Abhaya",
    photo: "https://images.pexels.com/photos/38344607/pexels-photo-38344607.jpeg?auto=compress&cs=tinysrgb&w=400",
    text: "The women's group helped me start a small business and stand on my own feet after my husband passed away.",
  },
  {
    id: "t4",
    name: "Venkatesh Rao",
    role: "Farmer, Health Camp Beneficiary",
    photo: "https://images.pexels.com/photos/16447736/pexels-photo-16447736.jpeg?auto=compress&cs=tinysrgb&w=400",
    text: "A free health camp caught my condition early. The volunteers even followed up to make sure I completed my treatment.",
  },
  {
    id: "t5",
    name: "Sunitha K.",
    role: "Girl-Child Scholarship Recipient",
    photo: "https://images.pexels.com/photos/10646431/pexels-photo-10646431.jpeg?auto=compress&cs=tinysrgb&w=400",
    text: "The scholarship meant I could stay in school instead of dropping out. Today I am studying to become a nurse.",
  },
  {
    id: "t6",
    name: "Mahesh Kumar",
    role: "Volunteer, Janma Vasudha",
    photo: "https://images.pexels.com/photos/6595899/pexels-photo-6595899.jpeg?auto=compress&cs=tinysrgb&w=400",
    text: "Volunteering with Janma showed me how much one weekend of planting trees and clearing waste can change a village.",
  },
];

export const CONTACT = {
  address: "H.No 2-6, Chitkul (V), Patancheru (M), Sangareddy (D), Hyderabad, T.S 502307",
  person: "Reddygari Bhaskar Reddy",
  phone: "9642865296",
  email: "info@janmafoundationngo.org",
};

export const MARQUEE_ITEMS = [
  "Health & Medical Support",
  "Government School Support",
  "Girl Child Education & Scholarships",
  "Women Empowerment & Support",
  "Environment & Waste Management",
  "Skill Development & Livelihoods for Women and Youth",
];
